// useBlockNavigation.ts
import { useContext, useEffect, useState } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export interface Blocker {
  status: 'idle' | 'blocked';
  proceed: () => void;
  cancel: () => void;
  nextLocation?: any;
}

export const useBlockNavigation = (when: boolean): Blocker => {
  const navigator = useContext(UNSAFE_NavigationContext).navigator as any;
  const [blocker, setBlocker] = useState<Blocker>({
    status: 'idle',
    proceed: () => {},
    cancel: () => {},
  });

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;
    const replace = navigator.replace;

    navigator.push = (...args: any[]) => {
      setBlocker({
        status: 'blocked',
        nextLocation: args[0],
        proceed: () => {
          push.apply(navigator, args);
          setBlocker((b) => ({
            ...b,
            status: 'idle',
            nextLocation: undefined,
          }));
        },
        cancel: () => {
          setBlocker((b) => ({
            ...b,
            status: 'idle',
            nextLocation: undefined,
          }));
        },
      });
    };

    navigator.replace = (...args: any[]) => {
      setBlocker({
        status: 'blocked',
        nextLocation: args[0],
        proceed: () => {
          replace.apply(navigator, args);
          setBlocker((b) => ({
            ...b,
            status: 'idle',
            nextLocation: undefined,
          }));
        },
        cancel: () => {
          setBlocker((b) => ({
            ...b,
            status: 'idle',
            nextLocation: undefined,
          }));
        },
      });
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [navigator, when]);

  return blocker;
};
